import { fromJS } from 'immutable';
import { useCallback, useMemo } from 'react';
import { isSucceeded } from 'reporting-data/asyncData/AsyncData';
import useFetchPropertyMetaDataForDataType from 'reporting-data/hooks/useFetchPropertyMetaDataForDataType';
import { getDataType, getReportDimensions } from 'reporting-data/report/reportGetters';
// @ts-expect-error Untyped import
import { setLimit } from 'reporting-action-components/lib/report-logic';
import { useContext } from 'react';
import { EnablementTrackingContext } from '../../../../monitoring/EnablementTrackingContext';
import generateTableReport from './generateTableReport';
const useFetchDimensionMetaData = report => {
  const dataType = getDataType(report);
  const dimensions = getReportDimensions(report);
  const dimensionMetaDataFetch = useFetchPropertyMetaDataForDataType(dataType, dimensions);
  const dimensionMetaData = isSucceeded(dimensionMetaDataFetch) ? dimensionMetaDataFetch.data : fromJS({});
  return dimensionMetaData;
};
const useConfigureReportWithCheckboxes = (report, onPreviewReportChange, rowLimit, setRowLimit, is2DSupported, selectedDimension) => {
  const dimensionMetaData = useFetchDimensionMetaData(report);
  const {
    enablementUsageTracker
  } = useContext(EnablementTrackingContext);
  const onRowLimitChange = useCallback(({
    target: {
      value
    }
  }) => {
    setRowLimit(Number(value));
    onPreviewReportChange(setLimit(value, report));
  }, [onPreviewReportChange, report, setRowLimit]);
  const tableReport = useMemo(() => generateTableReport(report, onPreviewReportChange, dimensionMetaData, rowLimit, onRowLimitChange, is2DSupported, selectedDimension, enablementUsageTracker), [report, onPreviewReportChange, is2DSupported, selectedDimension, dimensionMetaData, rowLimit, onRowLimitChange, enablementUsageTracker]);
  return tableReport;
};
export default useConfigureReportWithCheckboxes;